namespace Seac.Commons {
	class ExceptionsParser {
		public init(): void {
			// Centralizzo la gestione degli errori delle chiamate ajax, in modo che sia valida anche per i componenti DevExpress
			$.ajaxSetup({  
				error: (response: JQuery.jqXHR, textStatus: JQuery.Ajax.ErrorTextStatus, errorThrown: string) => Seac.Commons.exceptionsParser.parsejqXHRResponse(response)
			});
		}

		/**
		 * Metodo che riceve in input la request fallita e decodifca il messaggio di errore corretto
		 * Altrimenti mostra un errore generico
		 * @param response Response di tipo `XMLHttpRequest`
		 */
		public parseXMLHttpRequestErrorResponse(response: XMLHttpRequest): void {
			this.parseResponse(response.status, response.responseText);
		}

		/**
		 * Metodo che riceve in input la request fallita e decodifca il messaggio di errore corretto
		 * Altrimenti mostra un errore generico
		 * @param response Response di tipo `JQuery.jqXHR`
		 */
		public parsejqXHRResponse(response: JQuery.jqXHR): void {
			this.parseResponse(response.status, response.responseText || response.statusText);
		}

		/**
		 * Gestisce la response in base al codice di errore e al tipo di dato contenuto nella response
		 * @param status StatusCode della response
		 * @param responseText ResponseText contenuto nella response
		 */
		private parseResponse(status: Seac.Models.HttpRequestResultCode, responseText: string): void {
			// Controllo di che tipo di exception si tratta confrontando il codice di errore e verificando se sono contenute alcune proprietà "chiave"
			if (status === Seac.Models.HttpRequestResultCode.BadRequest && responseText &&
				responseText.indexOf(nameof(() => (<PTAZException>null).ExceptionKey)) !== -1 &&
				responseText.indexOf(nameof(() => (<PTAZException>null).ExceptionValue)) !== -1) {
				this.parsePTAZExceptionsString(responseText);
			}else if (status === Seac.Models.HttpRequestResultCode.NotAcceptable && responseText &&
				responseText.indexOf(nameof(() => (<ValidationErrorAjaxField>null).ErrorMessage)) !== -1 &&
				responseText.indexOf(nameof(() => (<ValidationErrorAjaxField>null).FieldName)) !== -1) {
				// Utilizziamo il codice di errore 406 nel caso in cui vengano restituiti errori di validazione
				// Converto l'oggetto degli errori in una struttura di dati
				this.parsePTAZAjaxValidationExceptionString(responseText);
			}else if (status === Seac.Models.HttpRequestResultCode.Forbidden) {
				Seac.Commons.notificationManager.addTitleNotification(Seac.Resources.Common.permesso_negato, Seac.Resources.Common.errore_esecuzione_richiesta, Seac.Commons.NotificationType.error, true);
			}else {
				// Altrimenti se non è una exception gestita, mostro un errore generico
				if (responseText && responseText.indexOf(nameof(() => (<Exception>null).StackTrace)) !== -1) {
					const genericException: Exception = JSON.parse(responseText);
					console.log(genericException.StackTrace);
					Seac.Commons.notificationManager.addTitleNotification(genericException.Message, Seac.Resources.Common.errore_esecuzione_richiesta, Seac.Commons.NotificationType.error, true);
				}else {
					console.log(responseText);
					const notificaText = responseText.substring(responseText.indexOf(': ') + 2, responseText.indexOf(' at'));
					Seac.Commons.notificationManager.addTitleNotification(notificaText, Seac.Resources.Common.errore_esecuzione_richiesta, Seac.Commons.NotificationType.error, true);
				}
			}
		}

		/**
		 * Decodifica la stringa dell'eccezione PTAZException e mostra la stringa di errore localizzata
		 * @param exceptionsString JSON contenetente la serializzazione dell'eccezione
		 */
		private parsePTAZExceptionsString(exceptionsString: string): void {
			const ptazException: PTAZException = JSON.parse(exceptionsString);
			let errorMessage: string;
			let templateString: string = Seac.Resources.Exceptions[ptazException.ExceptionKey];
			if (!!ptazException.AdditionalData && templateString) {
				// Nel caso in cui ci siano dei parametri addizionali, formatto la stinga con i valori ricevuti
				errorMessage = templateString.format(...ptazException.AdditionalData);
			}else if (templateString) {
				// Se esiste la stringa e non ci sono parmaetri mostro la stringa
				errorMessage = templateString;
			}else {
				// In caso non sia stata trovata la stringa, mostro un messaggio che indica che l'eccezione non è stata tradotta
				errorMessage = Seac.Resources.Exceptions.PTAZException_non_tradotta.format(ptazException.ExceptionKey);
			}
			console.log(ptazException.StackTrace);
			Seac.Commons.notificationManager.addSimpleNotification(errorMessage, Seac.Commons.NotificationType.error, true);
		}

		/**
		 * Decodifica la stringa dell'eccezione PTAZAjaxValidationException e mostra gli errori all'interno della form
		 * @param exceptionsString JSON contenetente la serializzazione dell'eccezione
		 */
		private parsePTAZAjaxValidationExceptionString(exceptionString: string): void {
			const ptazAjaxValidationException: PTAZAjaxValidationException = JSON.parse(exceptionString);

			// Elimino tutte le notifiche precedenti
			//Seac.Commons.notificationManager.clearNotifications().then(()=>{
				ptazAjaxValidationException.ValidationErrorAjaxFieldList.forEach((errorMessage: ValidationErrorAjaxField) => {
					// Per ogni errore vado a mostrare il messaggio di validazione
					Seac.Commons.validationDisplay.show(errorMessage.FieldName, errorMessage.ErrorMessage);
				});
			//})

		}
	}

	export interface ValidationErrorAjaxField {
		FieldName: string;
		ErrorMessage: string;
	}

	export interface PTAZAjaxValidationException extends Exception {
		ValidationErrorAjaxFieldList: Array<ValidationErrorAjaxField>;
	}

	export interface PTAZException extends Exception {
		AdditionalData: Array<string>;
		ExceptionKey: string;
		ExceptionValue: PTAZExceptionsEnum;
	}

	interface Exception {
		Data: object;
		HResult: number;
		HelpLink?: string;
		InnerException?: any;
		Message: string;
		Source: string;
		StackTrace: string;
	}

	export enum PTAZExceptionsEnum {
		ArticoloImportFieldNonTrovato = 1
	}

	export const exceptionsParser: ExceptionsParser = new ExceptionsParser();
	jQuery(document).ready(() => {
		exceptionsParser.init();
	});
}
